<input
    style="display: none"
    #fileupload
    type="file"
    (change)="onFileSelected($event)"
    [accept]="accept()"
    [multiple]="multiple()"
/>

<ng-content select="ai-button" />
